(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7942],{

/***/ 33726:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/house-of-senco",
      function () {
        return __webpack_require__(40936);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/Bag.a1f0136c.jpg","height":480,"width":380,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAYDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAiEAABAwEJAQAAAAAAAAAAAAABAAIDEQQHEhMUISIxQYH/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABgRAQADAQAAAAAAAAAAAAAAAAEAAhEh/9oADAMBAAIRAxEAPwCdd/JDJqXsslMzk6MtqQdhXEe/T9RERKjKmtXOT//Z"});

/***/ }),

/***/ 10450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/Everyday-Fine-Jewellry.a47d5390.jpg","height":480,"width":380,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAYDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAACAwACAwAAAAAAAAAAAAABAgADEQQFMUFh/8QAFQEBAQAAAAAAAAAAAAAAAAAABAX/xAAZEQEAAwEBAAAAAAAAAAAAAAABAAIRE0H/2gAMAwEAAhEDEQA/ALq9fw7XWm6ktYoYsKQDp0aTp876+xEQHS4uMolKoaeT/9k="});

/***/ }),

/***/ 42913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/Lab-Grown-Diamonds.650f919a.jpg","height":480,"width":380,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAYDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAABAwQDAQAAAAAAAAAAAAABAAIDBAURMRIUQaH/xAAUAQEAAAAAAAAAAAAAAAAAAAAC/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAECIf/aAAwDAQACEQMRAD8AgrxJbI6Smt0FYw9cuLyyDJ5HeXbPn1ERFLB1Wn//2Q=="});

/***/ }),

/***/ 83892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/Mens-Jewellery.67eba827.jpg","height":480,"width":380,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAYDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAdEAACAgMAAwAAAAAAAAAAAAABAgADBAUSETFB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAYEQEAAwEAAAAAAAAAAAAAAAABAAIRMf/aAAwDAQACEQMRAD8Am9i4ra5LNmzrk22dI4YluPHoj4IiIQ2Vs48n/9k="});

/***/ }),

/***/ 73756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/The-House_1.6ac73adb.jpg","height":634,"width":545,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAL/xAAeEAABBAIDAQAAAAAAAAAAAAABAAIEEQMFEhUxgf/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAXEQADAQAAAAAAAAAAAAAAAAAAAQIS/9oADAMBAAIRAxEAPwCIO6wu2fWNhOkcMVAMLRQFeXQr7aIiLKFpn//Z"});

/***/ }),

/***/ 21666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/The-House_2.2e981021.jpg","height":634,"width":545,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAgEAABAgUFAAAAAAAAAAAAAAABAAMCBRESIQQTMVFh/8QAFQEBAQAAAAAAAAAAAAAAAAAABAX/xAAXEQEBAQEAAAAAAAAAAAAAAAABAAIh/9oADAMBAAIRAxEAPwCc0sJm8xjdfugdcre7vZcIArmh874REQl7VDIF/9k="});

/***/ }),

/***/ 38215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/account.67824c8b.svg","height":24,"width":24});

/***/ }),

/***/ 40936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ house_of_senco; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/images/logo-h.png
/* harmony default export */ var logo_h = ({"src":"/_next/static/media/logo-h.fec954b4.png","height":180,"width":1218,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAABlBMVEXh4eHp6enzUUCMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAADklEQVR4nGNgYGBgBGEAAA8AAy8Md0AAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/assets/images/logo-botom.png
/* harmony default export */ var logo_botom = ({"src":"/_next/static/media/logo-botom.61639a76.png","height":69,"width":744,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAAD1BMVEXj4+P19fX////Y2Njp6elJ6nmrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAEUlEQVR4nGNgYmRgYGFmZAIAAD0ADlEY++cAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/styles/houseOfSenco.module.scss
var houseOfSenco_module = __webpack_require__(98525);
var houseOfSenco_module_default = /*#__PURE__*/__webpack_require__.n(houseOfSenco_module);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./src/store/slices/cart.ts
var cart = __webpack_require__(45066);
// EXTERNAL MODULE: ./src/store/slices/wishlist.ts
var wishlist = __webpack_require__(78271);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
;// CONCATENATED MODULE: ./src/components/house-of-senco/header/desktop_header.tsx














var DesktopHeader = function() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var wishlistState = (0,es/* useSelector */.v9)(wishlist/* selectWishlist */.jq);
    moment_timezone_default().tz.setDefault("Asia/Kolkata");
    var currentDate = moment_timezone_default()();
    var startDate = moment_timezone_default()("2024-12-21", "YYYY-MM-DD").startOf("day");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (houseOfSenco_module_default()).desktop_header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (houseOfSenco_module_default()).header_mid,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (houseOfSenco_module_default()).container,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row align-items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (houseOfSenco_module_default()).logo,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: logo_h,
                                            alt: "logo"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (houseOfSenco_module_default()).list_ul,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: authState.user ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    href: "/account/profile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "ACCOUNT"
                                                        })
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: authState.isUserLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                    animation: "border",
                                                    size: "sm"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "ACCOUNT"
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (houseOfSenco_module_default()).logo_bottom,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: logo_botom,
                            alt: "logo Bottom"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (houseOfSenco_module_default()).nav,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (houseOfSenco_module_default()).container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: (houseOfSenco_module_default()).navbar_dropdown,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#",
                                            children: "JEWELLERY"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (houseOfSenco_module_default()).dropdown,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            href: "https://www.sennes.in/collections/lab-grown-diamonds-jewellery",
                                                            target: "_blank",
                                                            children: [
                                                                "Lab Grown Diamonds",
                                                                " "
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://sencogoldanddiamonds.com/jewellery/category/aham-collection",
                                                            target: "_blank",
                                                            children: "Aham"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://everlite.com/",
                                                            target: "_blank",
                                                            children: "Everlite"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.sennes.in/category/bags-and-accessories",
                                        target: "_blank",
                                        children: "BAGS"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: (houseOfSenco_module_default()).navbar_dropdown,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#",
                                            children: " BRANDS"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (houseOfSenco_module_default()).dropdown,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://www.sennes.in/",
                                                            target: "_blank",
                                                            children: "Sennes"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://sencogoldanddiamonds.com/jewellery/category/aham-collection",
                                                            target: "_blank",
                                                            children: "Aham"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://everlite.com/",
                                                            target: "_blank",
                                                            children: "Everlite"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var desktop_header = (DesktopHeader);

;// CONCATENATED MODULE: ./src/assets/images/logom.png
/* harmony default export */ var logom = ({"src":"/_next/static/media/logom.1c11d1b9.png","height":273,"width":1224,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEXY2Nj29vb5+fn7+/v39/ft7e3f39/v7++EZQt2AAAABnRSTlP9+0VrPiUaxy/uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGElEQVR4nGNgYGBjYwMSDKxMjOzsjMwsAAHSADc5kFnXAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Nav.js + 2 modules
var Nav = __webpack_require__(96122);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Navbar.js + 11 modules
var Navbar = __webpack_require__(38643);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/NavDropdown.js
var NavDropdown = __webpack_require__(24214);
;// CONCATENATED MODULE: ./src/components/house-of-senco/header/mobile_header.tsx















var MobileHeader = function() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    moment_timezone_default().tz.setDefault("Asia/Kolkata");
    var currentDate = moment_timezone_default()();
    var startDate = moment_timezone_default()("2024-12-21", "YYYY-MM-DD").startOf("day");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (houseOfSenco_module_default()).mobile_header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (houseOfSenco_module_default()).logo_mobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: logom,
                    alt: "logo"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "house-of-senco-mobile-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                    expand: "lg",
                    className: "bg-body-tertiary",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        fluid: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default.Brand */.Z.Brand, {
                                children: [
                                    " ",
                                    authState.user ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        passHref: true,
                                        style: {
                                            cursor: "pointer"
                                        },
                                        href: "/account/profile",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "img-fluid pointer",
                                            src: __webpack_require__(38215),
                                            width: 29,
                                            height: 29,
                                            alt: "Account",
                                            priority: true,
                                            unoptimized: true
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: authState.isUserLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                            animation: "border",
                                            size: "sm"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "img-fluid pointer",
                                                src: __webpack_require__(38215),
                                                width: 29,
                                                height: 29,
                                                alt: "Account",
                                                priority: true,
                                                unoptimized: true
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default.Toggle */.Z.Toggle, {
                                "aria-controls": "navbarScroll"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default.Collapse */.Z.Collapse, {
                                id: "navbarScroll",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* default */.Z, {
                                    className: "me-auto my-2 my-lg-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavDropdown/* default */.Z, {
                                            title: "JEWELLERY",
                                            id: "navbarScrollingDropdown",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavDropdown/* default.Item */.Z.Item, {
                                                    href: "https://www.sennes.in/collections/lab-grown-diamonds-jewellery",
                                                    target: "_blank",
                                                    children: [
                                                        "Lab Grown Diamonds",
                                                        " "
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Divider */.Z.Divider, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Item */.Z.Item, {
                                                    href: "https://sencogoldanddiamonds.com/jewellery/category/aham-collection",
                                                    target: "_blank",
                                                    children: "Aham"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Divider */.Z.Divider, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Item */.Z.Item, {
                                                    href: "https://everlite.com/",
                                                    target: "_blank",
                                                    children: "Everlite"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Divider */.Z.Divider, {
                                                    className: "mb-0"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                            href: "https://www.sennes.in/category/bags-and-accessories",
                                            target: "_blank",
                                            children: "BAGS"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavDropdown/* default */.Z, {
                                            title: "BRANDS",
                                            id: "navbarScrollingDropdown",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Item */.Z.Item, {
                                                    href: "https://www.sennes.in/",
                                                    target: "_blank",
                                                    children: "Sennes"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Divider */.Z.Divider, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Item */.Z.Item, {
                                                    href: "https://sencogoldanddiamonds.com/jewellery/category/aham-collection",
                                                    target: "_blank",
                                                    children: "Aham"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Divider */.Z.Divider, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Item */.Z.Item, {
                                                    href: "https://everlite.com/",
                                                    target: "_blank",
                                                    children: "Everlite"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Divider */.Z.Divider, {
                                                    className: "mb-0"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mobile_header = (MobileHeader);

;// CONCATENATED MODULE: ./src/components/house-of-senco/header/index.tsx




var Header = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_header, {})
        ]
    });
};
/* harmony default export */ var header = (Header);

// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(13390);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
;// CONCATENATED MODULE: ./src/assets/images/banner-h.jpg
/* harmony default export */ var banner_h = ({"src":"/_next/static/media/banner-h.6d904456.jpg","height":944,"width":2667,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIDBAUhEpGx/8QAFAEBAAAAAAAAAAAAAAAAAAAAAf/EABYRAQEBAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8Ai7dSvHhsVK2JoeQQSd65tPrj2iIiYa//2Q=="});
;// CONCATENATED MODULE: ./src/components/house-of-senco/banner/banner.tsx









var Banner = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "house-senco",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (houseOfSenco_module_default()).banner_slide,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                pagination: true,
                modules: [
                    swiper_esm/* Pagination */.tl
                ],
                className: "mySwiper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (houseOfSenco_module_default()).image,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: banner_h,
                            alt: ""
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var banner = (Banner);

;// CONCATENATED MODULE: ./src/components/house-of-senco/collecttions/collecttions.tsx




var Collecttions = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (houseOfSenco_module_default()).our_collecttions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((houseOfSenco_module_default()).container, " ", "container"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (houseOfSenco_module_default()).our_collecttions_head,
                    children: [
                        "OUR ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "COLLECTIONS"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row g-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (houseOfSenco_module_default()).our_collecttions_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: __webpack_require__(83892),
                                            alt: "our collecttions"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (houseOfSenco_module_default()).our_collecttions_text,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row g-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-8",
                                                    children: "Mens Jewellery"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-4 pointer-cursor",
                                                    onClick: function() {
                                                        return window.open("https://sencogoldanddiamonds.com/jewellery/category/aham-collection", "_blank");
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: "SHOP NOW"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (houseOfSenco_module_default()).our_collecttions_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: __webpack_require__(7652),
                                            alt: "our collecttions"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (houseOfSenco_module_default()).our_collecttions_text,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row g-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-8",
                                                    children: "Bag"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-4 pointer-cursor",
                                                    onClick: function() {
                                                        return window.open("https://www.sennes.in/category/bags-and-accessories", "_blank");
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: "SHOP NOW"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (houseOfSenco_module_default()).our_collecttions_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: __webpack_require__(10450),
                                            alt: "our collecttions"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (houseOfSenco_module_default()).our_collecttions_text,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row g-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-8",
                                                    children: "Everyday Fine Jewellry"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-4 pointer-cursor",
                                                    onClick: function() {
                                                        return window.open("https://everlite.com/", "_blank");
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: "SHOP NOW"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (houseOfSenco_module_default()).our_collecttions_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: __webpack_require__(42913),
                                            alt: "our collecttions"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (houseOfSenco_module_default()).our_collecttions_text,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row g-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-8",
                                                    children: "Lab Grown Diamonds"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-4 pointer-cursor",
                                                    onClick: function() {
                                                        return window.open("https://www.sennes.in/collections/lab-grown-diamonds-jewellery", "_blank");
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: "SHOP NOW"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var collecttions = (Collecttions);

;// CONCATENATED MODULE: ./src/assets/images/1.jpg
/* harmony default export */ var _1 = ({"src":"/_next/static/media/1.3ac44bc7.jpg","height":944,"width":2667,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAACAgAHAAAAAAAAAAAAAAABAgADBAYREhMhof/EABUBAQEAAAAAAAAAAAAAAAAAAAED/8QAGREAAQUAAAAAAAAAAAAAAAAAAAECAzEy/9oADAMBAAIRAxEAPwCGzba9iYcud3HZbUuoHSgKQPTERLR5QHWf/9k="});
;// CONCATENATED MODULE: ./src/components/house-of-senco/sennes-aham/sennes-first.tsx





var SennesFirst = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (houseOfSenco_module_default()).sennes,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (houseOfSenco_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (houseOfSenco_module_default()).image_sennes,
                onClick: function() {
                    return window.open("https://www.sennes.in/", "_blank");
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: _1,
                    alt: ""
                })
            })
        })
    });
};
/* harmony default export */ var sennes_first = (SennesFirst);

;// CONCATENATED MODULE: ./src/assets/images/aham1.jpg
/* harmony default export */ var aham1 = ({"src":"/_next/static/media/aham1.16de50d0.jpg","height":790,"width":1670,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAeEAACAgICAwAAAAAAAAAAAAABAgADBAUREiExgf/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAWEQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhEDEQA/AJ/q3rp1WN1x6S17uLGZexIAPA8+vkREJCfK3//Z"});
;// CONCATENATED MODULE: ./src/components/house-of-senco/sennes-aham/aham.tsx





var Aham = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (houseOfSenco_module_default()).aham,
        onClick: function() {
            return window.open("https://sencogoldanddiamonds.com/jewellery/category/aham-collection", "_blank");
        },
        style: {
            cursor: "pointer"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (houseOfSenco_module_default()).image_aham,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: aham1,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (houseOfSenco_module_default()).aham_overlay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (houseOfSenco_module_default()).container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (houseOfSenco_module_default()).aham_card,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (houseOfSenco_module_default()).sen_text,
                                children: "Aham"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Designed for modern and sophisticated gentlemen to command attention, Aham’s Men Jewellery by Senco exudes dignified demeanour and cosmopolitan flair. Express your appreciation for fine craftsmanship and luxury with our signature collection of rings, bracelets, cufflinks, ear-studs, chains and pendants. Meticulously crafted in platinum, diamond, gold and silver, Aham jewellery speaks with a refined and timeless voice."
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var aham = (Aham);

;// CONCATENATED MODULE: ./src/assets/images/everliebg1.jpg
/* harmony default export */ var everliebg1 = ({"src":"/_next/static/media/everliebg1.3b96df22.jpg","height":790,"width":1670,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAbEAACAwADAAAAAAAAAAAAAAACAwABBBIhYf/EABUBAQEAAAAAAAAAAAAAAAAAAAMG/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAhMf/aAAwDAQACEQMRAD8Ao8aF50EpQ8RAKqu/IiIByoHW/9k="});
;// CONCATENATED MODULE: ./src/components/house-of-senco/sennes-aham/sennes-second.tsx





var SennesSecond = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (houseOfSenco_module_default()).sennes,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (houseOfSenco_module_default()).container,
            onClick: function() {
                return window.open("https://everlite.com/", "_blank");
            },
            style: {
                cursor: "pointer"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (houseOfSenco_module_default()).image_sennes,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: everliebg1,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (houseOfSenco_module_default()).senns_overlay,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (houseOfSenco_module_default()).senns_card,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (houseOfSenco_module_default()).sen_text,
                                children: "Everlite"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Indulge in the exquisite allure of Everlite by Senco Gold & Diamonds, meticulously crafted to elevate the modern woman’s glamour. A testament to sophistication and elegance, each piece is designed for those who appreciate luxurious subtlety in their everyday attire. Adorn yourself with HUID hallmarked jewellery, featuring the radiant gleam of gold, the timeless allure of diamonds, and the prestigious sheen of platinum. Illuminate your presence with the unparalleled brilliance of Everlite!"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var sennes_second = (SennesSecond);

;// CONCATENATED MODULE: ./src/components/house-of-senco/sennes-aham/index.tsx





var SennesAham = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sennes_first, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(aham, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sennes_second, {})
        ]
    });
};
/* harmony default export */ var sennes_aham = (SennesAham);

;// CONCATENATED MODULE: ./src/assets/images/labgrown_banner.jpg
/* harmony default export */ var labgrown_banner = ({"src":"/_next/static/media/labgrown_banner.bb89ff6b.jpg","height":790,"width":1670,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAAABgEFAAAAAAAAAAAAAAAAAQIDBDERBQYSEyH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AkZWnw422mWG46SN2N3rcMz5GvN3ivKAAAf/Z"});
;// CONCATENATED MODULE: ./src/components/house-of-senco/house/house.tsx





var House = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (houseOfSenco_module_default()).the_house,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (houseOfSenco_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (houseOfSenco_module_default()).the_house_head,
                    children: [
                        "THE ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "HOUSE"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pe-md-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (houseOfSenco_module_default()).ex_heading,
                                        children: [
                                            "EXPERIENCE ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " THE",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " ARTISTRY",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " OF",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " LUXURY"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "House of Senco from Senco Gold and Diamonds redefines luxury with an 80-year legacy of elegance and trust. We invite you to experience a world where timeless sophistication meets unparalleled craftsmanship."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Our mission is to be the quintessential destination for those who seek the finest in luxury. From exquisite bags to gold and diamond jewellery, Lab Grown Diamonds, and men’s jewellery, House of Senco offers a curated selection that transcends the ordinary. We cater to the most discerning tastes, creating an atmosphere of prestige and indulgence that is, aspirational."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "With decades of expertise, we bring together the finest luxury designs from our house of brands, Sennes, Everlite and Aham, all under one roof. Our commitment to excellence and customer trust ensures that every piece embodies timeless sophistication and exclusivity."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "At House of Senco, we are dedicated to crafting an experience of redefined luxury. Our vision is to become synonymous with opulence, setting new standards in the pursuit of refined living while honouring our rich heritage and legacy. Indulge in the extraordinary and discover a world where luxury is timeless."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row g-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (houseOfSenco_module_default()).know_video,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: labgrown_banner,
                                                alt: ""
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-6 pointer-cursor",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (houseOfSenco_module_default()).know_video,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                onClick: function() {
                                                    return window.open("https://www.sennes.in/category/bags-and-accessories", "_blank");
                                                },
                                                src: __webpack_require__(73756),
                                                alt: "our collecttions"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-6 pointer-cursor",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (houseOfSenco_module_default()).know_video,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                onClick: function() {
                                                    return window.open("https://www.sennes.in/category/bags-and-accessories", "_blank");
                                                },
                                                src: __webpack_require__(21666),
                                                alt: "our collecttions"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var house = (House);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./src/components/house-of-senco/trend_updates/trend_updates.tsx












var TrendUpdates = function() {
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            email: ""
        },
        validationSchema: yup_es/* object */.Ry({
            email: yup_es/* string */.Z_().email("Invalid email format")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, param) {
                var resetForm, data, ref, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resetForm = param.resetForm;
                            if (!values.email.length) {
                                _ctx.next = 14;
                                break;
                            }
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return http_client/* default.post */.Z.post(endpoints/* default.auth.subscribe */.Z.auth.subscribe(), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                type: "house_of_senco_page"
                            }));
                        case 5:
                            data = _ctx.sent.data;
                            (0,react_toastify_esm/* toast */.Am)(data.message, {
                                type: "success"
                            });
                            resetForm();
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](2);
                            ;
                            if ((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
                                (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                    type: "error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error"
                                });
                            }
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        10
                    ]
                ]);
            }));
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (houseOfSenco_module_default()).trend_updates,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (houseOfSenco_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: " Get trend updates, style tips and more"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    onSubmit: formik.handleSubmit,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (houseOfSenco_module_default()).trend_conainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                type: "email",
                                placeholder: "YOUR EMAIL"
                            }, formik.getFieldProps("email"))),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "submit",
                                children: [
                                    "SUBSCRIBE ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-arrow-right"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var trend_updates = (TrendUpdates);

;// CONCATENATED MODULE: ./src/assets/images/fooer-logo.png
/* harmony default export */ var fooer_logo = ({"src":"/_next/static/media/fooer-logo.3c3416b4.png","height":361,"width":1448,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAACVBMVEVRRSo+MBNIOx/+NA4xAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAE0lEQVR4nGNggAFGRkYmJiZGRgAAQgAMWUc1tgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/components/house-of-senco/footer/footer.tsx






var Footer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: (houseOfSenco_module_default()).footer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (houseOfSenco_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (houseOfSenco_module_default()).footer_logo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: fooer_logo,
                        alt: "Senco Gold & Diamonds Footer Logo"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row justify-content-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Customer Support"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We are happy to help you with your purchase"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (houseOfSenco_module_default()).quick_link,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "mt-4 mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: " Call 1800-103-0017"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        passHref: true,
                                                        href: "/about-us",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: " About Us"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: "The House Of Senco"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (houseOfSenco_module_default()).quick_link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                passHref: true,
                                                href: "/faq",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: " FAQs"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                passHref: true,
                                                href: "/offers-terms-condition",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Offers Terms & Conditions"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                passHref: true,
                                                href: "/shipping-policy",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Shipping Policy"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                passHref: true,
                                                href: "/return-and-refund-policy",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: " Return / Exchange Policy"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                passHref: true,
                                                href: "/offers-terms-condition",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Terms of Use"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                passHref: true,
                                                href: "/customer-service",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: " Customer Services"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (houseOfSenco_module_default()).footer_bottom,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "\xa9 2024, House of Senco ( A Senco Gold Limited Company )"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "All Rights Reserved. "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    passHref: true,
                                    href: "/offers-terms-condition",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: " Terms & Conditions "
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    passHref: true,
                                    href: "/privacy-policy",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: " Privacy Policy "
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./src/lib/tryOnTracking.ts
var tryOnTracking = __webpack_require__(68763);
// EXTERNAL MODULE: ./src/components/auth/auth-modal.tsx + 3 modules
var auth_modal = __webpack_require__(76565);
// EXTERNAL MODULE: ./src/components/auth/billing-address-modal.tsx
var billing_address_modal = __webpack_require__(29543);
// EXTERNAL MODULE: ./src/components/auth/sccount-selection-modal.tsx
var sccount_selection_modal = __webpack_require__(95117);
// EXTERNAL MODULE: ./src/components/auth/customer-consent.tsx
var customer_consent = __webpack_require__(38956);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/house-of-senco.tsx





















var HouseOfSenco = function() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var wishlistState = (0,es/* useSelector */.v9)(wishlist/* selectWishlist */.jq);
    (0,react.useEffect)(function() {
        (0,tryOnTracking/* initTryOnTracking */.j)();
        dispatch((0,auth/* fetchAuthUser */.zA)()).then(function(data) {
            if (data.payload) {
                dispatch((0,wishlist/* fetchWishlistItems */.nf)(data.payload.id));
                (0,tryOnTracking/* initTryOnTracking */.j)(data.payload.id);
            }
        });
        dispatch((0,cart/* fetchCartItems */.Vw)());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "House of Senco"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(banner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(collecttions, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sennes_aham, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(house, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(trend_updates, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_modal/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(billing_address_modal/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sccount_selection_modal/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(customer_consent/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                autoClose: 2000,
                theme: "colored",
                newestOnTop: true,
                position: "top-center"
            })
        ]
    });
};
/* harmony default export */ var house_of_senco = (HouseOfSenco);


/***/ }),

/***/ 98525:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_bar":"houseOfSenco_top_bar__Jr2Md","container":"houseOfSenco_container__3OrFC","header_mid":"houseOfSenco_header_mid__yM5pv","input":"houseOfSenco_input___YUXL","logo":"houseOfSenco_logo__gPvEX","list_ul":"houseOfSenco_list_ul__bTWzf","logo_bottom":"houseOfSenco_logo_bottom__JZnvF","nav":"houseOfSenco_nav__sQIIQ","navbar_dropdown":"houseOfSenco_navbar_dropdown__NYMPX","dropdown":"houseOfSenco_dropdown__8zPH5","mobile_header":"houseOfSenco_mobile_header__PV2LY","desktop_header":"houseOfSenco_desktop_header__41SEE","logo_mobile":"houseOfSenco_logo_mobile__PSJ1M","mobile_list":"houseOfSenco_mobile_list__RIwA5","mobile_list_container":"houseOfSenco_mobile_list_container__8yReF","banner_slide":"houseOfSenco_banner_slide__1AqRz","image":"houseOfSenco_image___inMI","our_catagories":"houseOfSenco_our_catagories__xOty1","our_catagories_head":"houseOfSenco_our_catagories_head__ZKWC0","our_catagories_card":"houseOfSenco_our_catagories_card__klTqf","our_catagories_text":"houseOfSenco_our_catagories_text__AEt1e","our_collecttions":"houseOfSenco_our_collecttions__9JZM9","our_collecttions_head":"houseOfSenco_our_collecttions_head__IqKzR","our_collecttions_card":"houseOfSenco_our_collecttions_card__DUrDk","our_collecttions_text":"houseOfSenco_our_collecttions_text__whVXu","sennes":"houseOfSenco_sennes__iQiY0","our_sennes_head":"houseOfSenco_our_sennes_head__c5H_9","image_sennes":"houseOfSenco_image_sennes__YQnvY","senns_overlay":"houseOfSenco_senns_overlay__lF1xN","senns_card":"houseOfSenco_senns_card__bNosi","sen_text":"houseOfSenco_sen_text__rZLLp","aham":"houseOfSenco_aham__Y1QzO","our_aham_head":"houseOfSenco_our_aham_head__eT6Py","image_aham":"houseOfSenco_image_aham__jT9aY","aham_overlay":"houseOfSenco_aham_overlay__zlnCe","aham_card":"houseOfSenco_aham_card__9kDle","our_bestsellers":"houseOfSenco_our_bestsellers__XlpDg","our_bestsellers_head":"houseOfSenco_our_bestsellers_head__dSb3r","our_bestsellers_card":"houseOfSenco_our_bestsellers_card__FtJXp","our_bestsellers_text":"houseOfSenco_our_bestsellers_text__xq9gi","seeall":"houseOfSenco_seeall__fzDz1","the_house":"houseOfSenco_the_house__Qn_Ig","the_house_head":"houseOfSenco_the_house_head__mxf_I","ex_heading":"houseOfSenco_ex_heading__JSe1f","know_video":"houseOfSenco_know_video__IwU5S","know":"houseOfSenco_know__GPWh3","trend_updates":"houseOfSenco_trend_updates__rLuT0","trend_conainer":"houseOfSenco_trend_conainer__mJG0s","footer":"houseOfSenco_footer__DYKv5","footer_logo":"houseOfSenco_footer_logo__j80QV","quick_link":"houseOfSenco_quick_link__NX8HQ","footer_bottom":"houseOfSenco_footer_bottom__AVICc"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,5675,9915,2640,3913,3495,6646,9774,2888,179], function() { return __webpack_exec__(33726); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);